import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../../app/guards'
import { EditExpensePage } from '../../../../features/finance/expense-pages'
import { taxRatesQueryOptions } from '../../../../features/finance/queries'

export const Route = createFileRoute('/_app/expenses/$expenseId/edit')({
  staticData: { crumb: 'expenseEdit' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'expenses.update'),
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(taxRatesQueryOptions)
  },
  component: EditExpensePage,
})
